import { useGetConversionPairsQuery } from '../store/conversion-pairs-api';
import { useShowResponseStatus } from '@/shared';

export const useGetConversionPairs = () => {
  const { data, isLoading, isError } = useGetConversionPairsQuery(undefined, {
    pollingInterval: 60000,
  });

  useShowResponseStatus({
    isError,
    errorMassage: 'При получении торговых пар произошла ошибка',
  });

  return {
    data,
    isLoading,
  };
};
